export default __webpack_public_path__ + "static/media/certificate.9920ba6b.png";